import { Provider } from 'react-redux';

import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { addConfig } from './Redux/appStateSlice';
import { setSavedParks } from './Redux/savedParksSlice';
import { persistor, store } from './Redux/store';
import { IS_PRODUCTION_ENV } from './const';

if (IS_PRODUCTION_ENV) {
  ReactGA.initialize("G-G01ZSG0XDS");
}

const container = document.getElementById("root");
const root = createRoot(container);

// The following block will transfer the users old saved parks and put them into the new setup
// Maybe delete this block in a year or so, late 2026
persistor.subscribe(() => {
  const { bootstrapped } = persistor.getState();
  if (bootstrapped) {
    const oldSaved = localStorage.getItem("SavedParks");
    if (oldSaved) {
      try {
        const parsed = JSON.parse(oldSaved);
        if (Array.isArray(parsed)) {
          store.dispatch(setSavedParks(parsed));
          localStorage.removeItem("SavedParks");
        }
      } catch (e) {
        console.error("Failed to migrate old saved parks", e);
      }
    }
  }
});

// config is needed for the whole app, call it first no matter what page we are on
async function init() {
  const res = await fetch("/json/content/config.json");
  const config = await res.json();
  store.dispatch(addConfig(config));

  root.render(
    <StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </StrictMode>,
  );
}

init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
